// extracted by mini-css-extract-plugin
export var divider = "_t9-0";
export var systemMessage = "_t9-1";